//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        photos: Array,
        keyFn: Function,
        urlFn: Function,
        downloadFn: [Function, Boolean],
        removeFn: [Function, Boolean],
        noScrimHide: Boolean,
        noEscHide: Boolean,
    },

    data() {
        return {
            isOpen: false,
            photoKey: null,
        };
    },

    methods: {
        open(photo) {
            this.photoKey = this.keyFn(photo);
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        },
        prev() {
            this.$refs.carousel.previous();
        },
        next() {
            this.$refs.carousel.next();
        },
        goToIndex(idx) {
            this.$refs.carousel.goTo(this.keyFn(this.photos[idx]));
        },
        async remove(photo) {
            const idx = this.photos.findIndex(p => this.keyFn(p) === this.photoKey);

            if (!(await this.removeFn(photo)))
                return;

            if (this.isOpen && this.keyFn(photo) === this.photoKey) {
                if (this.photos.length) {
                    if (idx === this.photos.length) {
                        this.goToIndex(idx - 1);
                    } else {
                        this.goToIndex(idx);
                    }
                } else {
                    this.close();
                }
            }
        },
    },
};
